// HotContestBanner.tsx
import React from "react";
import { Grid, Paper, Box, Button, Typography, Avatar } from "@mui/material";
import { getStatusColorByStatusName } from "./utils/getStatusColorByStatusName";

interface HotContestBannerProps {
  bannerImage: string;
  contestDescription?: string;
  logoImage: string;
  title: string;
  subtitle: string;
  votesCount: string;
  activitiesCount: string;
  usersCount: string;
  contestStatus?: string;
  expiryTime: Date;
  detailPage?: () => void;
}

const HotContestBanner: React.FC<HotContestBannerProps> = ({
  bannerImage,
  contestDescription,
  logoImage,
  title,
  subtitle,
  votesCount,
  activitiesCount,
  usersCount,
  contestStatus,
  expiryTime,
  detailPage
}) => {
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      lg={3}
      sx={{
        width: "100px"
      }}
    >
      <Paper
        onClick={detailPage}
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          borderRadius: "32px",
          overflow: "hidden",
          backgroundColor: "#245c9c",
          transition: "transform 0.3s",
          "&:hover": {
            transform: "scale(1.05)"
          },
          cursor: "pointer"
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "auto",
            paddingTop: "33.33%",
            overflow: "hidden",
            zIndex: 1,
            marginBottom: "-10%"
          }}
        >
          <img
            src={bannerImage}
            alt="Banner"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.5s",
              zIndex: 0
            }}
          />
        </Box>
        <Box
          sx={{
            padding: "1.5rem;",
            zIndex: 10,
            backgroundColor: "#245c9c",
            borderRadius: "32px"
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            className="token-header"
          >
            <Box
              display="flex"
              alignItems="center"
              className="token-profile"
              sx={{ flexGrow: 1, overflow: "hidden" }}
            >
              <Avatar
                src={logoImage}
                sx={{
                  width: 50,
                  height: 50,
                  flexShrink: 0
                }}
              />
              <Box sx={{ minWidth: 0, ml: 2 }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "20px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                  noWrap // Prevent wrapping
                >
                  {title}
                </Typography>
                <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "#919191",
                      fontWeight: "600",
                      fontSize: "16px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: 0
                    }}
                    noWrap
                  >
                    {subtitle}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Box display="flex" alignItems="center">
              <Button
                variant="contained"
                sx={{
                  top: -15,
                  mt: 2,
                  height: "25px",
                  backgroundColor: getStatusColorByStatusName(
                    contestStatus as any
                  ),
                  color: "white",
                  borderRadius: "16px",
                  textTransform: "none"
                }}
              >
                {contestStatus}
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: "#ffb703",
              p: 2,
              borderRadius: "16px"
            }}
          >
            <Box display="flex" justifyContent="space-between">
              <Box>
                <Typography variant="body2" sx={{ color: "#5b5555" }}>
                  vote
                </Typography>
                <Typography variant="body1" sx={{ color: "white" }}>
                  {votesCount}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" sx={{ color: "#5b5555" }}>
                  Users
                </Typography>
                <Typography variant="body1" sx={{ color: "white" }}>
                  {usersCount}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" sx={{ color: "#5b5555" }}>
                  Activities
                </Typography>
                <Typography variant="body1" sx={{ color: "white" }}>
                  {activitiesCount}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Grid>
  );
};

export default HotContestBanner;
